module.exports = __webpack_public_path__ + "img/option3.25e55ea2.png";